/**
 * StudentSettingsScreen — « Paramètres » de l'élève (route `settings`), à la place de
 * `student/account/SettingsTabNavigator.js` quand l'espace élève est allumé.
 *
 * Une route, cinq pages : la liste et ses quatre pages (Général, Adresse, Profil, Réglages), tenues
 * par l'état de l'écran. `initialTab` (l'index d'un onglet d'aujourd'hui) ouvre une page directement.
 * Patron A : les valeurs du compte (`studentSettingsViewModel`), recouvertes par les brouillons et
 * enregistrées par `useStudentSettingsState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import {
    StudentSettingsAddressPage,
    StudentSettingsGeneralPage,
    StudentSettingsPage,
    StudentSettingsPreferencesPage,
    StudentSettingsProfilePage,
} from "../../../../../../design-system/student"
import { studentSettingsViewModel } from "../../../../view-models/student/Account/studentSettingsViewModel"
import { type StudentSpaceScreenProps } from "../studentSpaceRouteTypes"
import { useStudentSettingsState, useStudentSettingsUi } from "./useStudentSettingsState"

export function StudentSettingsScreen(props: StudentSpaceScreenProps) {
    const [ui, dispatchUi] = useStudentSettingsUi(props.route?.params?.initialTab)
    const vm = useSelector((state: unknown) => studentSettingsViewModel(state, ui.drafts.preferences))
    const pages = useStudentSettingsState(vm, ui, dispatchUi)

    switch (pages.view) {
        case "general":
            return <StudentSettingsGeneralPage {...pages.general} />
        case "address":
            return <StudentSettingsAddressPage {...pages.address} />
        case "profile":
            return <StudentSettingsProfilePage {...pages.profile} />
        case "preferences":
            return <StudentSettingsPreferencesPage {...pages.preferences} />
        default:
            return <StudentSettingsPage {...pages.hub} />
    }
}
